var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorMomentum8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "304.5px",
    height: "184.833px",
    viewBox: "0 0 304.5 184.833",
    enableBackground: "new 0 0 304.5 184.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mom0_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mom1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mom2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "mom3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "mom4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "mom5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "mom6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "mom7"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "mom8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3099D5",
    d: "M182.404,83.124v-0.051c0.162,0.033,0.33,0.051,0.5,0.051c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5 c-0.17,0-0.338,0.018-0.5,0.05v-0.05h-25v5H182.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1996CE",
    d: "M208.705,68.124v-0.021c0.068,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.131,0.014-0.199,0.02v-0.02h-51v5H208.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1783AA",
    d: "M235.705,53.124c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5h-78v5H235.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14748E",
    d: "M262.705,38.124v-0.021c0.066,0.005,0.131,0.021,0.199,0.021c1.381,0,2.5-1.119,2.5-2.5 s-1.119-2.5-2.5-2.5c-0.068,0-0.133,0.014-0.199,0.02v-0.02h-105v5H262.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M289.936,23.124V23.12c1.367-0.018,2.469-1.127,2.469-2.496c0-1.371-1.102-2.48-2.469-2.498v-0.002 H157.404v5H289.936z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 289.936,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#14748E",
    cx: 263.006,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1783AA",
    cx: 236.006,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1996CE",
    cx: 209.006,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3099D5",
    cx: 182.154,
    cy: 171.667,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 156.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 151.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 146.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 141.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 136.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 131.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 126.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 121.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 116.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 111.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 106.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 101.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 96.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 156.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 151.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 146.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 141.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 136.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 131.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 126.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 121.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 116.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 111.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 106.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 101.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 96.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 156.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 151.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 146.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 141.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 136.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 131.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 126.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 121.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 116.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 111.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 106.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 101.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.006,
    y: 96.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 156.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 151.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 146.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 141.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 136.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 131.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 126.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 121.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 116.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 111.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 106.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 101.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 96.63,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 156.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 151.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 146.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 141.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 136.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 131.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 126.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 121.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 116.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 111.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 106.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 101.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 96.63,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.154,
    y: 86.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 86.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 81.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 76.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.006,
    y: 71.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 86.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 81.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 76.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 71.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 66.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 61.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.152,
    y: 56.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 86.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 81.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 76.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 71.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 66.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 61.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 56.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 51.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 46.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.006,
    y: 41.124,
    fill: "#3099D5",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 86.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 81.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 76.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 71.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 66.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 61.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 56.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 51.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 46.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 41.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 36.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 31.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.936,
    y: 26.124,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 2.562,
    fill: "#1C75BC",
    width: 2,
    height: 179.709
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 91.895,
    fill: "#1C75BC",
    width: 300,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M123.17,102.396v0.051c-0.162-0.033-0.328-0.051-0.5-0.051c-1.381,0-2.5,1.119-2.5,2.5 s1.119,2.5,2.5,2.5c0.172,0,0.338-0.018,0.5-0.051v0.051h25v-5H123.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M96.869,117.396v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h51v-5H96.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M69.869,132.396c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5h78v-5H69.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M42.869,147.396v0.02c-0.066-0.004-0.131-0.02-0.199-0.02c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5 c0.068,0,0.133-0.014,0.199-0.02v0.02h105v-5H42.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D3D4",
    d: "M15.639,162.396v0.004c-1.365,0.018-2.469,1.127-2.469,2.496c0,1.371,1.104,2.48,2.469,2.498v0.002 H148.17v-5H15.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 15.639,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 42.568,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 69.568,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 96.568,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D3D4",
    cx: 123.422,
    cy: 13.852,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.568,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 25.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 30.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 35.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 40.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 45.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 50.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 55.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 60.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 65.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 70.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 75.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 80.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 85.89,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.422,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.568,
    y: 111.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 111.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.422,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 111.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 131.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 136.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.568,
    y: 141.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 96.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 101.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 106.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 111.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 116.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 121.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 126.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 131.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 136.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 141.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 146.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 151.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.639,
    y: 156.396,
    fill: "#D1D3D4",
    width: 2,
    height: 3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M11.883,13.405c0-1.465,0.357-2.703,1.072-3.713c0.715-1.012,1.672-1.517,2.867-1.517 c2.496,0,3.744,1.821,3.744,5.464c0,1.704-0.338,3.064-1.012,4.08s-1.619,1.523-2.834,1.523c-1.309,0-2.275-0.469-2.9-1.406 S11.883,15.422,11.883,13.405z M13.859,13.537c0,1.431,0.141,2.483,0.418,3.157c0.279,0.674,0.74,1.01,1.385,1.01 c0.697,0,1.193-0.303,1.486-0.912c0.293-0.607,0.439-1.689,0.439-3.248c0-1.449-0.141-2.451-0.42-3.002 c-0.281-0.553-0.742-0.828-1.381-0.828C14.502,9.714,13.859,10.988,13.859,13.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M42.084,19.238v-7.734l-2.182,1.312v-1.832c1.4-0.678,2.51-1.518,3.324-2.52h0.762v10.774H42.084z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M66.469,19.097V18.54l3.398-5.003c0.678-1.001,1.018-1.843,1.018-2.526 c0-0.811-0.486-1.217-1.457-1.217c-0.742,0-1.34,0.394-1.795,1.18l-1.281-1.011c0.254-0.513,0.652-0.938,1.197-1.278 c0.545-0.339,1.146-0.509,1.805-0.509c1.1,0,1.959,0.251,2.578,0.751c0.621,0.5,0.932,1.195,0.932,2.084 c0,0.814-0.398,1.83-1.195,3.047l-2.197,3.347H73.5v1.692H66.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M93.215,18.195l0.951-1.472c0.566,0.6,1.182,0.9,1.846,0.9c1.211,0,1.816-0.568,1.816-1.707 c0-0.518-0.176-0.938-0.527-1.264c-0.352-0.324-0.824-0.486-1.42-0.486h-0.338V12.6h0.285c1.094,0,1.641-0.456,1.641-1.37 c0-0.957-0.51-1.436-1.529-1.436c-0.527,0-1.041,0.25-1.539,0.748L93.508,9.23c0.229-0.283,0.588-0.53,1.076-0.739 c0.488-0.211,0.977-0.315,1.465-0.315c1.068,0,1.902,0.244,2.5,0.732c0.6,0.488,0.898,1.172,0.898,2.051 c0,1.045-0.449,1.841-1.348,2.388c1.137,0.547,1.707,1.44,1.707,2.681c0,1.021-0.34,1.812-1.016,2.373 s-1.609,0.843-2.801,0.843C94.906,19.243,93.98,18.894,93.215,18.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M125.377,16.291v2.806h-1.83v-2.806h-4.887V15.2l5.883-6.878h0.834v6.46h1.084v1.509H125.377z  M123.547,11.56l-2.754,3.223h2.754V11.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M178.814,176.036l0.754-1.568c0.775,0.605,1.443,0.908,2,0.908c1.23,0,1.846-0.756,1.846-2.27 c0-0.729-0.141-1.258-0.418-1.594c-0.279-0.334-0.744-0.502-1.398-0.502c-0.592,0-1.168,0.291-1.729,0.873l-0.756-0.492v-5.316 h5.779v1.619h-3.947v1.918c0.322-0.146,0.707-0.219,1.156-0.219c1.055,0,1.867,0.305,2.436,0.914 c0.568,0.611,0.854,1.475,0.854,2.594c0,2.729-1.271,4.094-3.816,4.094C180.52,176.995,179.6,176.675,178.814,176.036z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M209.465,165.907l1.01,1.068c-0.727,0.381-1.389,0.881-1.984,1.502 c-0.596,0.619-1.006,1.232-1.23,1.838c0.508-0.229,0.947-0.344,1.318-0.344c1.012,0,1.822,0.314,2.436,0.941 s0.92,1.475,0.92,2.545c0,1.055-0.314,1.908-0.941,2.561c-0.629,0.65-1.42,0.977-2.377,0.977c-2.5,0-3.75-1.561-3.75-4.68 c0-1.309,0.482-2.633,1.445-3.973C207.275,167.001,208.326,166.19,209.465,165.907z M206.842,173.421 c0,1.305,0.555,1.955,1.664,1.955c0.453,0,0.814-0.162,1.084-0.486c0.268-0.324,0.402-0.777,0.402-1.359 c0-0.596-0.141-1.066-0.422-1.416s-0.643-0.523-1.088-0.523C207.389,171.591,206.842,172.2,206.842,173.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M235.539,177.563h-2.088c0.795-2.451,2.162-5.457,4.102-9.018h-4.914v-1.758h7.396v0.814l-0.967,1.822 c-0.316,0.615-0.652,1.289-1.004,2.02c-0.352,0.729-0.693,1.471-1.025,2.227c-0.332,0.754-0.625,1.459-0.879,2.115 C235.906,176.444,235.699,177.036,235.539,177.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E8",
    d: "M261.184,170.976c-0.391-0.264-0.711-0.613-0.959-1.049c-0.25-0.434-0.373-0.869-0.373-1.303 c0-0.826,0.291-1.48,0.875-1.967c0.582-0.486,1.332-0.729,2.244-0.729c0.982,0,1.748,0.242,2.301,0.729 c0.551,0.486,0.826,1.145,0.826,1.975c0,0.434-0.152,0.895-0.461,1.381c-0.307,0.484-0.645,0.826-1.01,1.021 c0.463,0.215,0.891,0.602,1.285,1.164c0.393,0.561,0.59,1.088,0.59,1.582c0,1.016-0.32,1.805-0.961,2.369 c-0.639,0.564-1.508,0.846-2.607,0.846c-1.107,0-1.963-0.275-2.566-0.828c-0.604-0.551-0.904-1.348-0.904-2.387 c0-0.537,0.16-1.064,0.48-1.582C260.262,171.681,260.676,171.272,261.184,170.976z M262.766,171.743 c-0.932,0.527-1.398,1.207-1.398,2.037c0,0.459,0.145,0.84,0.436,1.143s0.668,0.453,1.131,0.453 c0.488,0,0.889-0.133,1.199-0.398c0.309-0.266,0.465-0.617,0.465-1.051C264.598,173.185,263.986,172.456,262.766,171.743z  M263.146,170.243c0.273-0.127,0.516-0.363,0.725-0.707c0.211-0.344,0.316-0.656,0.316-0.934c0-0.322-0.111-0.58-0.334-0.77 c-0.223-0.191-0.516-0.285-0.883-0.285c-0.811,0-1.215,0.354-1.215,1.061c0,0.313,0.148,0.633,0.445,0.957 C262.5,169.89,262.814,170.116,263.146,170.243z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595B",
    d: "M289.154,177.054l-1.01-1.068c1.484-0.82,2.533-1.893,3.148-3.217 c-0.326,0.146-0.744,0.221-1.252,0.221c-1.006,0-1.816-0.313-2.432-0.938s-0.924-1.475-0.924-2.549 c0-1.064,0.316-1.926,0.945-2.586c0.631-0.658,1.422-0.988,2.373-0.988c2.5,0,3.75,1.572,3.75,4.717 c0,1.309-0.482,2.633-1.447,3.973C291.344,175.96,290.293,176.771,289.154,177.054z M288.627,169.429 c0,0.602,0.143,1.074,0.426,1.422c0.283,0.346,0.645,0.52,1.084,0.52c1.094,0,1.641-0.609,1.641-1.83 c0-1.328-0.555-1.992-1.664-1.992c-0.453,0-0.814,0.166-1.084,0.502C288.762,168.384,288.627,168.843,288.627,169.429z"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "mom9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorMomentum8);
export default __webpack_public_path__ + "static/media/indicator-momentum-8.7e8934fdbc8554ed2249e65de6870fde.svg";
export { ForwardRef as ReactComponent };